import axios from "axios";


const externalAPI = "https://api.grupohk.com.br:5003/api/v1/";
const testAPI = "https://apidemo.grupohk.com.br:5006/api/v1/";
const server151 = "https://apiteste1.grupohk.com.br:8002/api/v1/"
const ApiTeste = "https://apicomercial.grupohk.com.br:7006/api/v1/"
export default axios.create({
  baseURL: ApiTeste,
})